<div class="assinatura-container">
  <!-- Brand panel -->
  <div class="assinatura-brand-panel">
    <div class="brand-content animate-fade-in">
      <div class="brand-logo">
        <img src="/assets/img/identidade-visual/Logo.png" alt="Easy Consultório" />
      </div>

      <div class="brand-benefits">
        <div class="benefit-item" *ngFor="let feat of features; let i = index">
          <span class="benefit-icon" [ngClass]="{
            '': i % 4 === 0,
            'benefit-icon--cyan': i % 4 === 1,
            'benefit-icon--sky': i % 4 === 2,
            'benefit-icon--lavender': i % 4 === 3
          }">
            <span class="material-icons">{{ feat.icon }}</span>
          </span>
          <div class="benefit-text">
            <strong>{{ feat.label }}</strong>
          </div>
        </div>
      </div>

      <p class="brand-note">
        <span class="material-icons">verified</span>
        Todas as funcionalidades incluídas
      </p>
    </div>

    <div class="brand-decoration">
      <div class="swoosh swoosh-1"></div>
      <div class="swoosh swoosh-2"></div>
      <div class="swoosh swoosh-3"></div>
    </div>
  </div>

  <!-- Content panel -->
  <div class="assinatura-form-panel">

    <!-- Loading -->
    <div class="assinatura-card animate-slide-up" *ngIf="tela === 'loading'">
      <div class="loading-box">
        <mat-icon class="spin">autorenew</mat-icon>
        <p>Carregando informações...</p>
      </div>
    </div>

    <!-- ═══════════════ TELA: ASSINAR ═══════════════ -->
    <div class="assinatura-card animate-slide-up" *ngIf="tela === 'assinar'">
      <!-- Status banner -->
      <div class="status-banner" [class.status-banner--expired]="trialExpirado" [class.status-banner--active]="!trialExpirado">
        <span class="material-icons">{{ trialExpirado ? 'error_outline' : 'timer' }}</span>
        <span *ngIf="trialExpirado">Seu período de teste expirou</span>
        <span *ngIf="!trialExpirado && diasRestantes > 0">{{ diasRestantes }} {{ diasRestantes === 1 ? 'dia restante' : 'dias restantes' }} no teste gratuito</span>
        <span *ngIf="!trialExpirado && diasRestantes === 0">Assine agora para ter acesso completo ao sistema</span>
      </div>

      <div class="assinatura-header">
        <h1>Assine o Easy Consultório</h1>
        <p>Continue usando todas as funcionalidades sem interrupção</p>
      </div>

      <div class="plan-card">
        <div class="plan-card__header">
          <span class="plan-card__badge">Plano completo</span>
          <div class="plan-card__price">
            <span class="plan-card__currency">R$</span>
            <span class="plan-card__value">59</span>
            <span class="plan-card__period">/mês</span>
          </div>
        </div>

        <!-- Forma de pagamento -->
        <div class="forma-pagamento-section">
          <label class="section-label">Forma de pagamento</label>
          <div class="forma-pagamento-options">
            <label class="forma-option" *ngFor="let forma of formasPagamento"
              [class.forma-option--selected]="formaPagamentoSelecionada === forma.valor"
              (click)="formaPagamentoSelecionada = forma.valor">
              <input type="radio" name="formaPagamento" [value]="forma.valor"
                [(ngModel)]="formaPagamentoSelecionada" hidden />
              <span class="material-icons forma-option__icon">{{ forma.icone }}</span>
              <span class="forma-option__label">{{ forma.texto }}</span>
              <span class="forma-option__check" *ngIf="formaPagamentoSelecionada === forma.valor">
                <span class="material-icons">check_circle</span>
              </span>
            </label>
          </div>
        </div>

        <button class="assinar-btn" (click)="assinar()" [disabled]="loading">
          <span *ngIf="!loading">Assinar agora</span>
          <span *ngIf="loading" class="btn-loading">
            <mat-icon class="spin">autorenew</mat-icon>
            Processando...
          </span>
        </button>
      </div>

      <div class="contact-section">
        <p>Prefere falar com a gente?</p>
        <div class="contact-links">
          <a href="mailto:contato&#64;easyconsultorio.com.br" class="contact-link">
            <span class="material-icons">mail_outline</span>
            Email
          </a>
        </div>
      </div>

      <div class="back-link" *ngIf="!trialExpirado">
        <a routerLink="/painel">← Voltar ao painel</a>
      </div>
    </div>

    <!-- ═══════════════ TELA: PAGAMENTO ═══════════════ -->
    <div class="assinatura-card animate-slide-up" *ngIf="tela === 'pagamento' && resultadoPagamento">
      <div class="assinatura-header">
        <h1>Efetue o pagamento</h1>
        <p>Sua assinatura será ativada automaticamente após a confirmação</p>
      </div>

      <!-- PIX -->
      <div class="pagamento-box" *ngIf="resultadoPagamento.formaPagamento === 'PIX'">
        <div class="pagamento-badge pagamento-badge--pix">
          <span class="material-icons">qr_code_2</span>
          Pagamento via PIX
        </div>

        <div class="qrcode-container" *ngIf="resultadoPagamento.qrCodePixImagem">
          <img [src]="'data:image/png;base64,' + resultadoPagamento.qrCodePixImagem" alt="QR Code PIX" class="qrcode-img" />
        </div>

        <div class="pix-copia-cola" *ngIf="resultadoPagamento.qrCodePix">
          <label class="section-label">PIX Copia e Cola</label>
          <div class="copy-box">
            <code class="copy-text">{{ resultadoPagamento.qrCodePix }}</code>
            <button class="copy-btn" (click)="copiarQrCode()">
              <span class="material-icons">content_copy</span>
            </button>
          </div>
        </div>
      </div>

      <!-- Boleto -->
      <div class="pagamento-box" *ngIf="resultadoPagamento.formaPagamento === 'BOLETO'">
        <div class="pagamento-badge pagamento-badge--boleto">
          <span class="material-icons">receipt</span>
          Pagamento via Boleto
        </div>

        <p class="pagamento-info">
          O boleto foi gerado e pode levar até 3 dias úteis para compensação.
        </p>
      </div>

      <!-- Cartão -->
      <div class="pagamento-box" *ngIf="resultadoPagamento.formaPagamento === 'CREDIT_CARD'">
        <div class="pagamento-badge pagamento-badge--cartao">
          <span class="material-icons">credit_card</span>
          Pagamento via Cartão
        </div>

        <p class="pagamento-info">
          Seu cartão será cobrado automaticamente. O pagamento será confirmado em instantes.
        </p>
      </div>

      <!-- Link pagamento direto (funciona para todos) -->
      <div class="pagamento-link-section" *ngIf="resultadoPagamento.urlPagamento">
        <button class="pagamento-link-btn" (click)="abrirUrlPagamento()">
          <span class="material-icons">open_in_new</span>
          Acessar página de pagamento
        </button>
        <p class="pagamento-link-hint">Você será redirecionado para a página segura de pagamento</p>
      </div>

      <div class="pagamento-actions">
        <button class="btn-secondary" (click)="voltarParaGerenciar()">
          <span class="material-icons">arrow_back</span>
          Voltar
        </button>
      </div>
    </div>

    <!-- ═══════════════ TELA: GERENCIAR ═══════════════ -->
    <div class="assinatura-card assinatura-card--wide animate-slide-up" *ngIf="tela === 'gerenciar' && assinaturaStatus">
      <div class="assinatura-header">
        <h1>Minha assinatura</h1>
        <p>Gerencie seu plano Easy Consultório</p>
      </div>

      <!-- Status card -->
      <div class="status-card" [style.border-left-color]="statusInfo.cor">
        <div class="status-card__header">
          <div class="status-card__status">
            <span class="material-icons" [style.color]="statusInfo.cor">{{ statusInfo.icone }}</span>
            <span class="status-card__label" [style.color]="statusInfo.cor">{{ statusInfo.texto }}</span>
          </div>
          <div class="status-card__valor">
            <span class="status-card__currency">R$</span>
            <span class="status-card__price">{{ assinaturaStatus.valor | number:'1.2-2':'pt-BR' }}</span>
            <span class="status-card__period">/mês</span>
          </div>
        </div>

        <div class="status-card__details">
          <div class="detail-item">
            <span class="material-icons detail-item__icon">payment</span>
            <div class="detail-item__content">
              <span class="detail-item__label">Forma de pagamento</span>
              <span class="detail-item__value">
                <span class="material-icons" style="font-size: 16px; vertical-align: middle;">{{ formaPagamentoInfo.icone }}</span>
                {{ formaPagamentoInfo.texto }}
              </span>
            </div>
          </div>

          <div class="detail-item">
            <span class="material-icons detail-item__icon">event</span>
            <div class="detail-item__content">
              <span class="detail-item__label">Próximo vencimento</span>
              <span class="detail-item__value">
                {{ formatarData(assinaturaStatus.dataProximoVencimento) }}
                <span class="dias-badge" *ngIf="assinaturaStatus.ativa && diasAteVencimento > 0"
                  [class.dias-badge--alerta]="diasAteVencimento <= 5">
                  {{ diasAteVencimento }} {{ diasAteVencimento === 1 ? 'dia' : 'dias' }}
                </span>
              </span>
            </div>
          </div>

          <div class="detail-item">
            <span class="material-icons detail-item__icon">check_circle_outline</span>
            <div class="detail-item__content">
              <span class="detail-item__label">Último pagamento</span>
              <span class="detail-item__value">{{ formatarData(assinaturaStatus.dataUltimoPagamento) }}</span>
            </div>
          </div>
        </div>
      </div>

      <!-- Ações -->
      <div class="gerenciar-actions">
        <button class="action-btn action-btn--primary" (click)="obterLinkPagamento()" [disabled]="loading"
          *ngIf="assinaturaStatus.temCobrancaPendente">
          <span class="material-icons">receipt_long</span>
          <span *ngIf="!loading">Pagar</span>
          <span *ngIf="loading" class="btn-loading">
            <mat-icon class="spin">autorenew</mat-icon>
          </span>
        </button>

        <button class="action-btn action-btn--danger" (click)="cancelar()" [disabled]="loading"
          *ngIf="assinaturaStatus.status !== 3">
          <span class="material-icons">cancel</span>
          Cancelar assinatura
        </button>
      </div>

      <p class="cancelamento-aviso" *ngIf="assinaturaStatus.status !== 3">
        <span class="material-icons">info_outline</span>
        Ao cancelar uma assinatura, a assinatura permanecerá ativa até o final do período já pago. Não haverá estorno do valor referente ao ciclo atual.
      </p>

      <!-- Reativar (se cancelada/inadimplente) -->
      <div class="reativar-section" *ngIf="assinaturaStatus.status === 3 || assinaturaStatus.status === 5">
        <div class="reativar-card">
          <span class="material-icons reativar-card__icon">refresh</span>
          <div>
            <strong>Reative sua assinatura</strong>
            <p>Selecione uma forma de pagamento para reativar seu acesso.</p>
          </div>
        </div>

        <div class="forma-pagamento-section">
          <div class="forma-pagamento-options">
            <label class="forma-option" *ngFor="let forma of formasPagamento"
              [class.forma-option--selected]="formaPagamentoSelecionada === forma.valor"
              (click)="formaPagamentoSelecionada = forma.valor">
              <input type="radio" name="formaPagamentoReativar" [value]="forma.valor"
                [(ngModel)]="formaPagamentoSelecionada" hidden />
              <span class="material-icons forma-option__icon">{{ forma.icone }}</span>
              <span class="forma-option__label">{{ forma.texto }}</span>
              <span class="forma-option__check" *ngIf="formaPagamentoSelecionada === forma.valor">
                <span class="material-icons">check_circle</span>
              </span>
            </label>
          </div>

          <button class="assinar-btn" (click)="assinar()" [disabled]="loading" style="margin-top: 1rem;">
            <span *ngIf="!loading">Reativar assinatura</span>
            <span *ngIf="loading" class="btn-loading">
              <mat-icon class="spin">autorenew</mat-icon>
              Processando...
            </span>
          </button>
        </div>
      </div>

      <div class="back-link">
        <a routerLink="/painel">← Voltar ao painel</a>
      </div>
    </div>

  </div>
</div>
